import { makeStyles } from '@mui/styles';
import TextField from 'apollo-react/components/TextField';
import React from 'react';

import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { INPUT_MAX_HEIGHT } from '../constants';

const useStyles = makeStyles({
  root: {
    marginTop: 0,
    width: 188,
  },
  input: {
    maxHeight: INPUT_MAX_HEIGHT,
    minHeight: 0,
  },
});

const ReadOnlyOperator = ({ value, showLabel }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  return (
    <TextField
      className={classes.root}
      InputProps={{
        inputProps: {
          className: classes.input,
        },
      }}
      value={value}
      disabled
      label={showLabel ? translateString('Operator') : null}
    />
  );
};

export default ReadOnlyOperator;
